export const HELLOCLEVER_PAYMENT_METHOD = 'holypayment';
